// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ps[data-v-663cdfc5] {\n  padding-right: 15px;\n  z-index: 1;\n}\n.ps[data-v-663cdfc5] {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
